export const getDrawerPlacement = () => {
  if (document.documentElement.clientWidth < 768) {
    return "bottom";
  }
  return "right";
};
